var map = {
	"./afex-to-use-derivitecs-risk-portal.png": 2200,
	"./afex-using-derivitecs-risk-portal-for-collateral-management.png": 1960,
	"./be-prepared-operational-risk-management-in-2024.png": 3920,
	"./derivitec-expands-the-team-for-2015.png": 3866,
	"./derivitec-teams-up-with-messer-financial-software-to-provide-straight-through-risk-processing-for-pag.png": 9123,
	"./derivitec-to-showcase-at-camp-alphaville.png": 831,
	"./derivitec-wins-hedgeweeks-best-risk-management-software-provider-2018.png": 9358,
	"./hedgeweek-special-report-hedge-funds-derivatives-risk-2015.png": 5986,
	"./lets-be-clear-the-marginal-benefits-of-transparency-are-not-marginal.png": 3913,
	"./mirabella-to-use-derivitecs-risk-portal.png": 7350,
	"./world-first-to-use-derivitecs-risk-portal.png": 6305
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 743;